import script from "./ItemShare.vue?vue&type=script&lang=ts&setup=true"
export * from "./ItemShare.vue?vue&type=script&lang=ts&setup=true"

import "./ItemShare.vue?vue&type=style&index=0&id=8c932112&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c932112"]])

export default __exports__